/**
 * This is a helper function that makes it easy to filter out nullable/undefined values from an array
 *   It also asserts that the array values can not be nullable/undefined
 *
 * Example:
 *   const values: (string | null | undefined)[] = ['test-1', null, 'test-2', undefined, 'test-3'];
 *   const result = values.filter(isPresent)
 *   // result will be of type string[] and with values ['test-1','test-2','test-3']
 */
export function isPresent<T>(value: T): value is NonNullable<T> {
  return !!value;
}
